/*
 * HYETECH: purple dual-thumb price slider (assets/hyetech-price-slider.js)
 * ---------------------------------------------------------------------
 * Purely additive UI layer for snippets/price-facet.liquid. It never
 * touches Shopify Search & Discovery's real Min/Max text inputs' name
 * or param_name attributes - it only reads/writes their `value` and
 * dispatches native `input`/`change` events on them, which is exactly
 * what a person typing into those fields would trigger. Dawn's existing
 * <price-range> validation (assets/facets.js) and the debounced
 * facet-filters-form auto-submit keep working completely unmodified.
 *
 * Because Dawn's AJAX facet filtering replaces the price filter's
 * <details> markup wholesale on every filter change, a MutationObserver
 * re-binds this behaviour to any freshly-rendered slider automatically.
 */
(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setupSlider(container) {
    if (container.dataset.hyetechBound === 'true') return;
    container.dataset.hyetechBound = 'true';

    var wrapper = container.closest('.hyetech-price-filter');
    var minRange = container.querySelector('[data-hyetech-slider-min]');
    var maxRange = container.querySelector('[data-hyetech-slider-max]');
    var rangeFill = container.querySelector('.hyetech-price-slider__range');
    if (!wrapper || !minRange || !maxRange) return;

    var minText = wrapper.querySelector('[data-hyetech-price-text-min]');
    var maxText = wrapper.querySelector('[data-hyetech-price-text-max]');
    var applyButton = wrapper.querySelector('[data-hyetech-price-apply]');
    var rangeMax = Number(minRange.max) || 0;

    function updateFill() {
      var min = Number(minRange.value);
      var max = Number(maxRange.value);
      var left = rangeMax ? (min / rangeMax) * 100 : 0;
      var right = rangeMax ? (max / rangeMax) * 100 : 100;
      if (rangeFill) {
        rangeFill.style.left = left + '%';
        rangeFill.style.right = (100 - right) + '%';
      }
    }

    function onMinSlide() {
      var min = Number(minRange.value);
      var max = Number(maxRange.value);
      if (min > max) {
        min = max;
        minRange.value = String(min);
      }
      if (minText) minText.value = min;
      updateFill();
    }

    function onMaxSlide() {
      var min = Number(minRange.value);
      var max = Number(maxRange.value);
      if (max < min) {
        max = min;
        maxRange.value = String(max);
      }
      if (maxText) maxText.value = max;
      updateFill();
    }

    function commitMin() {
      if (!minText) return;
      minText.value = minRange.value;
      minText.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function commitMax() {
      if (!maxText) return;
      maxText.value = maxRange.value;
      maxText.dispatchEvent(new Event('change', { bubbles: true }));
    }

    minRange.addEventListener('input', onMinSlide);
    maxRange.addEventListener('input', onMaxSlide);
    minRange.addEventListener('change', commitMin);
    maxRange.addEventListener('change', commitMax);

    if (minText) {
      minText.addEventListener('change', function () {
        var value = clamp(parseFloat(minText.value) || 0, 0, rangeMax);
        minRange.value = String(value);
        updateFill();
      });
    }

    if (maxText) {
      maxText.addEventListener('change', function () {
        var value = clamp(parseFloat(maxText.value) || rangeMax, 0, rangeMax);
        maxRange.value = String(value);
        updateFill();
      });
    }

    if (applyButton) {
      applyButton.addEventListener('click', function () {
        if (minText) minText.dispatchEvent(new Event('input', { bubbles: true }));
        if (maxText) maxText.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    updateFill();
  }

  function init() {
    document.querySelectorAll('.hyetech-price-slider').forEach(setupSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  var facetsContainer = document.querySelector('.facets-container');
  if (facetsContainer && window.MutationObserver) {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        init();
      });
    });
    observer.observe(facetsContainer, { childList: true, subtree: true });
  }
})();
